<template>
  <div class="setting-advanced-knowledge">
    <div class="setting-advanced-knowledge-tips" v-if="showMsgTips">
      <p>机器人依赖知识库中的内容为顾客提供服务，知识库中的内容越丰富，则机器人可以成功解决问题的几率越高。</p>
      <svg-icon icon-class="close" class="knowledge-close-btn" @click.native="closeTips"></svg-icon>
    </div>
    <ul class="setting-advanced-tab-container module-item-style">
      <router-link :to="menu.path" tag="li" v-for="(menu, index) in tabbar" :class="$route.path == menu.path ? 'tabActived' : ''" :key="index" v-if="!menu.meta.hidden">{{menu.meta.title}}</router-link>
      <li class="recharge-btn" v-if="manageRoute">
		<div class="download">下载<a href="/Public/download/weiliao-knowledge-template.xls" download>《知识库数据导入模板》</a></div>
        <span class="wl-btn" @click="addNewPeoblem">
          新建问题
        </span>
        <span class="wl-btn-empty" @click="importData">
          导入数据
          <input type="file" ref="inportInput" hidden @change="importInputChange">
        </span>
        <span>
          <a class="wl-btn-empty" :href="exportUrl" download="">导出数据</a>
        </span>
      </li>
      <li class="recharge-btn" v-if="classRoute">
        <span class="wl-btn" @click="addNewClass">添加分类</span>
      </li>
    </ul>
    <div class="setting-knowledge-container">
      <transition name="fade-transform" mode="out-in">
        <router-view/>
      </transition>
    </div>

    <!--    问题dialog-->
    <el-dialog
        :title="dialogTitle"
        width="609px"
        v-if="manageRoute"
        class="editor-dialog"
        @closed="closeModal"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible">
      <el-form :model="problemForm">
        <el-form-item label="主问法">
          <el-input v-model="problemForm.standard" placeholder="请输入主问法" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="problemForm.name" placeholder="请选择分类">
            <el-option
                v-for="item in categoryList"
                :key="item.classId"
                :label="item.name"
                :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回答">
          <div v-if="showEditor" placeholder="请输入回答" ref="editor"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeModal">取 消</el-button>
        <el-button type="primary" @click="submitProblemForm">确 定</el-button>
      </div>
    </el-dialog>

    <!--    分类-dialog-->
    <el-dialog
        :title="dialogCategoryTitle"
        width="609px"
        v-if="classRoute"
        class="editor-dialog"
        @closed="closeClassModal"
        :close-on-click-modal="false"
        :visible.sync="dialogCategoryFormVisible">
      <el-form :model="problemForm">
        <el-form-item label="分类">
          <el-input v-model="categoryForm.name" placeholder="请输入分类" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeClassModal">取 消</el-button>
        <el-button type="primary" @click="submitClassForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import E from 'wangeditor'

  export default {
    name: 'setting-advanced-knowledge',
    data() {
      return {
        showMsgTips: true,
        dialogFormVisible: false,
        dialogCategoryFormVisible: false,
        showEditor: false,
        dialogTitle: '新建问题',
        dialogCategoryTitle: '增加分类',
        accept: 'image/gif, image/jpeg, image/png, image/jpg',
        fileaccept:'',
        editor: null,
        problemForm: {
          id:'',
          name: '',
          standard: '',
          external: ''
        },
        categoryList:[],
        categoryForm: {
          id: '',
          name: ''
        },
        editorIsNoContent:true,
        answerOnlyPic: false,
        exportUrl:''
      }
    },
    created() {

    },
    mounted() {
      eventBus.$on('getClass', (data) => {
        this.categoryList = data
      })
      eventBus.$on('editProblem', (data) => {
        this.editProblem(data)
      })
      eventBus.$on('editClass', (data) => {
        this.editClass(data)
      })
    },
    computed: {
      tabbar() {
        let menu = []
        let currenMenuMatched = this.$route.matched
        console.log('currenMenuMatched=====',currenMenuMatched)
        this.$store.state.permission.addRoutes.map((item) => {
          if (item.name == 'layout') {
            item.children.map(subItem => {
              if (subItem.path == currenMenuMatched[1].path) {

                console.log('subItem=====',subItem)
                subItem.children.map(subSubItem => {
                  if (subSubItem.path == currenMenuMatched[2].path) {
                    menu = subSubItem.children
                  }
                })
              }
            })
          }
        })
        return menu
      },
      manageRoute() {
        let route = this.$route
        if (route.name == 'settingAdvancedKnowledgeManagement') {
          this.exportUrl = process.env.VUE_APP_API_URL+'/wlapi/knowledge/outExecl'
          return true
        } else {
          return false
        }
      },
      classRoute() {
        let route = this.$route
        if (route.name == 'settingAdvancedKnowledgeCategory') {
          return true
        } else {
          return false
        }
      },
    },
    methods: {
      closeTips() {
        this.showMsgTips = false
      },
      closeModal() {
        this.showEditor = false
        this.dialogFormVisible = false
        this.problemForm = {
          id:'',
          name: '',
          standard: '',
          external: ''
        }
      },
      closeClassModal() {
        this.dialogCategoryFormVisible = false
        this.categoryForm.name = ''
      },
      initEditor(data) {
        let editor = new E(this.$refs.editor)
        this.editor = editor
        editor.customConfig.menus = [
          'head',
          'bold',
          'italic',
          'underline',
          'list',
          'justify',
          'image',
          'link',
        ]
        let _that = this
        editor.customConfig.linkImgCallback = function (url) {
          _that.answerOnlyPic = true
        }
        editor.customConfig.customUploadImg = function (files, insert) {
          let img = files[0]
          let type = img.type
          let size = img.size
          if (_that.accept.indexOf(type) == -1) {
            _that.$message({
              showClose: true,
              message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          if (size > 5242880) {
            _that.$message({
              showClose: true,
              message: '请选择5M以内的图片！',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          let formdata = new FormData()
          formdata.set('file', img)
          _that.$http.uploadImageAPI(formdata).then(res => {
            if (res.status == 1) {
              _that.answerOnlyPic = true
              insert(res.data)
            }
          })
          // files 是 input 中选中的文件列表
          // insert 是获取图片 url 后，插入到编辑器的方法

        }
        editor.create()

        editor.txt.html(data)
      },
      addNewPeoblem() {
        // this.dialogTitle = '新建问题'
        // this.showEditor = true
        // this.dialogFormVisible = true
        // this.$nextTick(() => {
        //   this.initEditor()
        // })
		localStorage.setItem('knowledgeObj',JSON.stringify({}))
		this.$router.push({
			path:"/setting-advanced-knowledge-addOrEdit"
		})
      },
      editProblem(data) {
        // this.dialogTitle = '编辑问题'
        // this.showEditor = true
        // this.dialogFormVisible = true
        // this.$nextTick(() => {
        //   this.initEditor(data.answer)
        //   this.problemForm = {
        //     id:data.problemId,
        //     name: data.className,
        //     standard:data.problem,
        //   }
        // })
		let knowledgeObj = {
			id:data.problemId,
			name: data.className,
			standard:data.problem,
			answer:data.answer,
			title:"编辑问题",
			relatedProblems:data.relatedProblems
		}
		localStorage.setItem('knowledgeObj',JSON.stringify(knowledgeObj))
		this.$router.push({
			path:"/setting-advanced-knowledge-addOrEdit"
		})
      },
      addNewClass() {
        this.dialogCategoryTitle = '添加分类'
        this.dialogCategoryFormVisible = true
      },
      editClass(data) {
        this.dialogCategoryTitle = '编辑分类'
        this.dialogCategoryFormVisible = true
        this.categoryForm.name = data.name
        this.categoryForm.id = data.classId
      },
      submitProblemForm() {
        let reg = /&nbsp;/g;
        let content = this.editor.txt.text()
        this.problemForm.external = this.editor.txt.html()
        if(this.$utils.u_isEmpty(this.problemForm.standard)) {
          this.$message({
            message: '主问法不能为空',
            type: 'error',
          })
          return  false
        }
        if(this.$utils.u_isEmpty(this.problemForm.name)) {
          this.$message({
            message: '请选择分类',
            type: 'error',
          })
          return  false
        }
        if(!this.answerOnlyPic && content.replace(reg,'').trim().length == 0){
          this.$message({
            message: '回答不能为空',
            type: 'error',
          })
          return false
        }
        this.$http.addOrEditProblemAPI(this.problemForm).then(res => {
          if(res.status == 1){
            eventBus.$emit('reloadProblemTable')
            this.closeModal()
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
      submitClassForm() {
        let postParam = {
          name: this.categoryForm.name
        }
        if (this.$utils.u_isEmpty(this.categoryForm.name)) {
          this.$message({
            message: '请输入分类名',
            type: 'error',
          })
          return false
        }
        if (this.categoryForm.id != '') {
          postParam.id = this.categoryForm.id
        }
        this.$http.addOrEditClassAPI(postParam).then(res => {
          if (res.status == 1) {
            this.closeClassModal()
            this.$message({
              message: res.msg,
              type: 'success',
            })
            eventBus.$emit('reloadClassTable')
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })

      },
      /**
       * 导入数据
       */
      importData(){
        this.$refs.inportInput.click()
      },
      importInputChange(e){
        let file = e.target.files[0]
        let size = file.size
        let name = file.name
        var suffix = name.substr(name.lastIndexOf("."));
        if(".xls" != suffix && ".xlsx" != suffix ){
          this.$message({
            showClose: true,
            message: '文件格式不正确，请选择Excel格式的文件导入',
            type: 'error',
            duration: 3 * 1000
          })
          return false;
        }
        let formdata = new FormData()
        formdata.set('file', file)
        this.$http.importDataAPI(formdata).then( res => {
          if(res.status == 1){
            eventBus.$emit('reloadProblemTable')
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })

      },
    }
  }
</script>

<style lang="scss">

  .setting-advanced-knowledge {
    .setting-advanced-knowledge-tips {
      border-radius: $mainBorderRadius;
      background-color: #fff2d7;
      border: 1px solid #ffdf9c;
      margin-bottom: 10px;
      line-height: 40px;
      font-size: 12px;
      color: #666;
      display: flex;
      padding: 0 19px;
      position: relative;

      .knowledge-close-btn {
        position: absolute;
        right: 0px;
        top: 50%;
        margin-top: -9px;
        cursor: pointer;
      }
    }

    .setting-advanced-tab-container {
      display: flex;
      padding: 24px 24px 17px;
      position: relative;

      li {
        margin-right: 40px;
        color: #333333;
        font-size: 12px;
        letter-spacing: 1.4px;
        cursor: pointer;
        padding-bottom: 7px;
      }

      .recharge-btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -20px;
        margin-right: 0;

        span + span {
          margin-left: 20px;
        }
		.download{
			display: inline-block;
			 font-size: 12px;
			 margin-right: 5px;
			 a{
			    color: $mainColor;
			    margin-left: 3px;
			 }
		}
      }
    }

    .setting-knowledge-container {
      margin-top: 15px;
    }

    .dialog-footer {
      text-align: center;
    }

    .el-form-item__label {
      float: none;
      font-weight: bold;
      color: #333;
    }

    .el-select {
      width: 100%;
    }

    .editor-dialog {
      li {
        list-style: inherit;
      }

      img {
        max-width: 300px !important;
      }

      a {
        color: $mainColor;
        text-decoration: underline;
      }
      .w-e-text-container{
        height: 230px!important;
      }
    }

  }
</style>
